import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import GrowthOSPage from "@/pages/GrowthOSPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<GrowthOSPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
